function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useDismiss, useFloating, useInteractions, useRole } from '@floating-ui/react';
import { useMemo, useState } from 'react';
import { useTestId } from '../../utils';
export function useDrawer(_ref) {
  var {
    isOpen,
    onClose,
    onCloseComplete,
    'data-testid': dataTestId = 'drawer',
    closeButtonAriaLabel = 'Close drawer'
  } = _ref;
  var getTestId = useTestId(dataTestId);
  var [labelId, setLabelId] = useState();
  var [descriptionId, setDescriptionId] = useState();
  var data = useFloating({
    open: isOpen,
    onOpenChange: onClose
  });
  var context = data.context;
  var dismiss = useDismiss(context, {
    outsidePressEvent: 'mousedown'
  });
  var role = useRole(context);
  var interactions = useInteractions([dismiss, role]);
  return useMemo(() => _objectSpread(_objectSpread(_objectSpread({
    isOpen,
    onClose,
    onCloseComplete,
    closeButtonAriaLabel,
    getTestId
  }, interactions), data), {}, {
    labelId,
    descriptionId,
    setLabelId,
    setDescriptionId
  }), [closeButtonAriaLabel, data, descriptionId, getTestId, interactions, isOpen, labelId, onClose, onCloseComplete]);
}
//# sourceMappingURL=useDrawer.js.map